// extracted by mini-css-extract-plugin
export default {"root":"Panel-module_root-eMiLN"};